




import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import InvoiceStatus from '@/models/Invoices/InvoiceStatus';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';

@Component({
  name: 'InvoiceStatus',
})
export default class extends GiganautVue {

  @Prop({required: true})
  status: InvoiceStatus;

  @Prop({required: true})
  location: StatusDisplayLocation;
  
  get textColor() {
    let color = "grey--text";
    switch (this.status) {
      case InvoiceStatus.Paid:
        color = "green--text";
        break;
      case InvoiceStatus.Pending:
      case InvoiceStatus.Draft:
      case InvoiceStatus.Submitted:
      case InvoiceStatus.Authorised:
        color = "orange--text";
        break;
      case InvoiceStatus.Voided:
      case InvoiceStatus.Deleted:
        color = "red--text";
        break;
      default:
        color = "grey--text";
        break;
    }
    return color;
  }

  get text() {
    let text = "";
    switch (this.status) {
      case InvoiceStatus.Pending:
        text = "PENDING";
        break;
      case InvoiceStatus.Draft:
        text = "SENT TO ACCOUNTING";
        break;
      case InvoiceStatus.Submitted:
        text = "SUBMITTED";
        break;
      case InvoiceStatus.Authorised:
        text = "AUTHORISED";
        break;
      case InvoiceStatus.Paid:
        text = "PAID";
        break;
      case InvoiceStatus.Voided:
        text = "VOIDED";
        break;
      case InvoiceStatus.Deleted:
        text = "DELETED";
        break;
      default:
        text = "UNKNOWN STATUS"
        break;
    }
    return text;
  }
  
  get classy() {
    const classes: string[] = [this.textColor]
    switch (this.location) {
      case StatusDisplayLocation.Title:
        classes.push("overline");
        classes.push("ma-2");
        break;
      case StatusDisplayLocation.Grid:
        classes.push("overline");
        break;
      case StatusDisplayLocation.SubTitle:
      default:
        classes.push("overline");
        classes.push("ma-2");
        break;
    }
    return classes;
  }
}
